module.exports = __webpack_public_path__ + "static/media/francisoVestita.14b51523.jpg";